<template>
  <v-app>
    <v-app-bar
      app
      fixed
      color="white"
      style="color:#137967"
    >
      <div class="d-flex flex-row justify-space-between" @click="goHome()" style="cursor: pointer">
        <v-img
          alt="HortusBox Logo"
          class=""
          contain
          :src="`${appStyle.logo}?height=60`"
          transition="scale-transition"
          height="40"
          :width="host === 'hortusbox' ? 168 : 231"
        />
      </div>

      <v-spacer></v-spacer>
      <div class="text-center" v-if="$vuetify.breakpoint.smAndDown">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="#0b755f"
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-menu</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="item in menu"
                :key="item.label">
                <v-btn @click="goTo(item.goto)" text >
                  <span class="mr-2" style="color:#0b755f">{{item.label}}</span>
                </v-btn>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      <div v-if="$vuetify.breakpoint.mdAndUp">

        <v-btn
          v-for="item in menu"
          :key="item.label"
          @click="goTo(item.goto)"
          text
        >
          <span class="mr-2" style="color:#0b755f">{{ item.label }}</span>
        </v-btn>

        <!-- <v-btn
          @click="goShop()"
          text
        >
          <span class="mr-2" style="color:#0b755f">Mon projet</span>
        </v-btn>

        <v-btn
          @click="goBlog()"
          text
        >
          <span class="mr-2" style="color:#0b755f">Blog</span>
        </v-btn>

        <v-btn
          @click="$store.commit('showContact', {from: 'btn', path: $route.path})"
          text
        >
          <span class="mr-2" style="color:#0b755f">Contact</span>
        </v-btn> -->
      </div>

    </v-app-bar>
  
    <v-content>
      <router-view></router-view>

      <section style="min-height:300px;background:#0b755f;color:white;padding-top: 2em;">
        <v-container style="max-width:940px">
        <v-row align="center">
          <v-col>
            <div class="d-flex social-cut">
              <a href="https://www.facebook.com/HortusBoxDesign" target="_blank">
                <v-icon color="white" x-large class="pa-1">mdi-facebook</v-icon>
              </a>
              <a href="https://www.instagram.com/hortusboxdesign/" target="_blank">
                <v-icon color="white" x-large class="pa-1">mdi-instagram</v-icon>
              </a>
              <a href="https://www.pinterest.fr/HortusBox/_created/" target="_blank">
                <v-icon color="white" x-large class="pa-1">mdi-pinterest</v-icon>
              </a>
              <a href="https://www.linkedin.com/company/hortusbox/" target="_blank">
                <v-icon color="white" x-large class="pa-1">mdi-linkedin</v-icon>
              </a>
              <a href="/faq" class="faq">
                FAQ
              </a>
            </div>
          </v-col>
          <v-col>
            <v-btn text color="white" @click="$router.push('/contact')">Nous contacter</v-btn>
            <br/>
            <v-btn text color="white" @click="$router.push('/qui-sommes-nous')">Qui sommes-nous ?</v-btn>
            <br/>
            <v-btn text color="white" target="_blank" href="https://storage.service.hortusbox.com/strapi/PAYSAGISME_2_0_HORTUSMINI_UN_NOUVEAU_SERVICE_SIMPLE_PRATIQUE_ET_PEU_ONEREUX_POUR_UN_BALCON_OU_UNE_TERRASSE_DE_REVE_EN_QUELQUES_CLICS_compressed_6957b27ed4.pdf">Communiqué de presse</v-btn>
            <br/>
            <v-btn text color="white" @click="$router.push('/policy')">Politique de Confidentialité</v-btn>
            <br/>
            <v-btn text color="white" @click="$router.push('/cgv')">Conditions Générales de Vente</v-btn>
          </v-col>
        </v-row>  
        <v-row>
          <br />
        </v-row>
          <v-row justify="center" align="center">
            <v-col align="center">
              <p>
                <!-- Hortus Box est une solution inédite et innovante qui permet à partir de son smartphone, de créer l'aménagement paysager de son jardin, terrasse ou balcon par un professionnel, sans connaissances préalables et surtout à moindre coût. La start-up est née du constat selon lequel le contexte actuel du marché du jardinage et du paysagisme n'offre que deux possibilités : allouer un budget très significatif en faisant appel à un paysagiste (résultat professionnel mais coûteux), ou faire soi-même avec un budget réduit mais pour un résultat souvent approximatif. -->
              </p>
              <p>
                <!-- Aujourd'hui Hortusbox permet aux propriétaires de jardin ou terrasse de réaliser leurs projets d'aménagement à l'aide d'un paysagiste concepteur mais toujours dans l'esprit faire soi-même ou "Do It Yourself". C'est ainsi une solution adaptée à la jeune génération connectée qui n'a ni les connaissances d'embellissement de jardin ni le budget pour faire appel à des paysagistes traditionnels. -->
              </p>
              <p>
                © HortusBox 2019 - {{(new Date()).getFullYear()}}. All Rights Reserved.
              </p>
              <p class="font-weight-thin" style="color:rgb(255 255 255 / 50%) !important; font-size:14px">
                Version: {{version}}
              </p>
            </v-col>
          </v-row>
        </v-container>
      </section>
    </v-content>


    <v-dialog
      v-model="contactShowIt"
      max-width="500"
    >
      <v-card class="py-3">
        <v-img 
        src="/gimc/storage/assets/card/popup.png?format=jpeg&height=180" 
        lazy-src="/gimc/storage/assets/card/popup.png?thumb=true" height="180px" contain>
        </v-img>
        <v-card-title class="headline">{{ contactTitle }}</v-card-title>
        <v-card-text>
          Inscrivez-vous pour être informé(e) des nouveautés HortusBox.
        </v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field label="Nom*" v-model="popup.name" required></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field label="Courriel*" type="email" v-model="popup.email" required></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea label="Un commentaire" v-model="popup.comment" ></v-textarea>
            </v-col>
          </v-row>
        </v-container>


        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            text
            @click="$store.commit('hideContact')"
          >
            Pas maintenant
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            :disabled="!popup.name || !popup.email"
            @click="send"
          >
            Envoyer
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
    <Promo />
  </v-app>
</template>

<script>
import axios from 'axios'
import { isMobile } from 'mobile-device-detect'
import { mapGetters, mapActions } from 'vuex'
import { useScriptTag } from '@vueuse/core'
import { constantes } from './store/app'

import Promo from './components/Promo.vue'
const contactTitle = 'Vous partez déjà ?'

export default {
  name: 'HortusBox',
  components: { Promo },
  data: () => ({
    isMobile,
    popupDisplayed: false,
    popupPromo: false,
    popup: {
      name: '',
      email: '',
      comment: ''
    },
    menu: [
      { label: "Nos Offres", goto: 'nos-offres' },
      { label: "Conseils et astuces ", goto: 'conseils' },
      { label: "Trouver mon style", goto: 'trouver-mon-style' },
      // { label: "FAQ", goto: 'faq' },
      { label: "Contact", goto: 'contact' },
      // { label: "Qui sommes-nous ?", goto: 'qui-sommes-nous' }
    ]
  }),

  methods: {
    ...mapActions('app', ['updateHost']),
    ...mapActions('strapi', ['getLandingPageConfig']),
    ...mapActions('strapiv2', ['load']),
    goTo (where) {
      switch (where) {
        case 'shop': this.goShop(); break
        // case 'blog': this.goBlog(); break
        case 'conseils': this.goBlog(); break
        // case 'contact':
          // this.$store.commit('showContact', {from: 'btn', path: this.$route.path})
          // break;
        default: {
          const path = `/${where}`
          if (this.$route.path !== path) {
            this.$router.push(path)
          }
        }
      }
    },
    goHome () {
      if (this.$route.path === '/') {
        return
      }
      this.$router.push('/')
    },
    goBlog () {
      window.location = '/conseils'
    },
    goShop () {
      if (this.$route.path === '/mon-projet') {
        return
      }
      this.$router.push('/mon-projet')
    },
    mouseLeftWindow () {
      const lpviewat = this.$cookies.get("lpviewat")
      const lpdoneat = this.$cookies.get("lpdoneat")
      if (!this.popupDisplayed && !lpviewat && !lpdoneat && !isMobile) {
        this.popupDisplayed = true
        this.$store.commit('showContact', {title: contactTitle, from: 'left', path: this.$route.path})
        // this.dialog = true
        this.$cookies.set('lpviewat', new Date(), '4h')
      }
    },
    send () {
      axios.post('/sky/web/contact', this.popup)
        .then(() => {
          this.$store.commit('hideContact')
          this.$cookies.set('lpdoneat', new Date(), '10y')
        })
        .catch(() => {
          this.$store.commit('hideContact')
        })
    },
  },
  async mounted () {
    await this.updateHost()
    await this.getLandingPageConfig()
    await this.load()
    if (this.host === constantes.HostLeroyMerlin) {
      useScriptTag('https://www.googletagmanager.com/gtag/js?id=G-XK8S4HPZT0', () => {
        window.dataLayer = window.dataLayer || []
        function gtag() {
          /* eslint-disable-next-line */
          dataLayer.push(arguments);
        }
        gtag('js', new Date());
        gtag('config', 'G-XK8S4HPZT0');
      })
      useScriptTag('https://www.googletagmanager.com/gtag/js?id=UA-123492035-3', () => {
        window.dataLayer = window.dataLayer || [];
        /* eslint-disable-next-line */
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date())
        gtag('config', 'UA-123492035-3')
      })
    }
    if (this.host === constantes.HostJardiland) {
      useScriptTag('https://www.googletagmanager.com/gtag/js?id=UA-123492035-4', () => {
        window.dataLayer = window.dataLayer || [];
        /* eslint-disable-next-line */
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date())
        gtag('config', 'UA-123492035-4')
      })
    }
    // document.addEventListener('mouseout', this.mouseLeftWindow, false)
  },
  computed: {
    ...mapGetters('app', ['isPartner', 'host', 'appStyle']),
    ...mapGetters(['version', 'versionCommit']),
    contactShowIt: {
      get () {
        return this.$store.state.contactShowIt
      },
      set (value) {
        this.$store.commit(value ? 'showContact' : 'hideContact')
      }
    },
    contactTitle () {
      return this.$store.state.contactTitle
    }
  }
};
</script>

<style scoped>
.grecaptcha-badge { visibility: hidden; }

.social-cut {
  color: white;
}

.social-cut a {
  text-decoration: none;
}

.faq {
  color: white;
  font-size: 32px;
  text-decoration: none;
}

</style>